export default "__VITE_ASSET__CMHvxOJY__"